import Metadata from "../../requests/apa/Metadata";
import DeviceStorage from "../../components/DeviceStorage/DeviceStorage";
import Translator from "../../requests/apa/Translator";
import { isAndroidDevice } from "../../AAFPersistenceManager/helpers/Utils";
import Utils from "../../utils/Utils";

let enableMultipleLang = false;
let streamsMaEnabled = [];
let settings_subtitles = [];
let settings_audios = [];
let groupIdsEnabled = [];
// Version que se usará en el api de EPG/CHANNEL
// let versionEpgChannel = getAppConfig().api_version;


//Funcion que consulta metadata para habilitar la nueva experiencia de MA LIVE
const init = function () {
  try {
    const value = Utils.getApaMetadataKey("multiple_languages_live",'{"enable":false}');
    
    if (value && typeof value == "object" && value.enable) {
      enableMultipleLang = value.enable;
    } else {
      enableMultipleLang = false;
    }
  } catch (error) {
    console.log("[MA_LIVE]-init-error", error);
  }
};

const initialize = function () {
  // Iniciando o no multiple audios en LIVE
  init();
  if (isEnabled) {
    // Se setea las llaves en metadata para el tipo de streamings
    initStremsEnabled();
    // Se cargan los lenguages por default para modal de Settings
    loadLanguagesSettingsUser();
    //cargando los groupsIds iniciales
    initGroupsIds();
    // Estableciendo la configuracion inicial en settings, si es que no existe 
    settingsInitial();
    console.log("[MA_LIVE]-streamsMaEnabled", streamsMaEnabled);
  }
};

const settingsInitial = function() {
  if(!DeviceStorage.getItem('default_lang_audio_live')){
    const defaultLang = isAndroidDevice() ? 'SPASPA': 'SPA';
    DeviceStorage.setItem('default_lang_audio_live', defaultLang);
  }
  if(!DeviceStorage.getItem('default_lang_subtitle_live')){
    DeviceStorage.setItem('default_lang_subtitle_live', 'off');
  }
}

// Funcion que carga los valores por default de audio y subtitulos en modal del apartado de settings.
const loadLanguagesSettingsUser = function () {
  try {
    // Se Obtiene llave regionalizada de metadata
    const value = Utils.getApaMetadataKey('live_configuration_audio_subtitle_settings', '{"audios":[{"option_id":"ENG","label_large": "button_live_audio_ORIGINAL"},{"option_id" : "SPA" , "label_large": "button_live_audio_ES"}, {"option_id":"POR", "label_large":"button_live_audio_PT"},{"option_id":"ENG","label_large": "button_live_audio_EN"}], "subtitles": [{"option_id":"ori", "label_large":"button_live_subtitle_ORIGINAL"}, {"option_id": "SPA","label_large":"button_live_subtitle_ES"}, {"option_id": "POR","label_large":"button_live_subtitle_PT"}, {"option_id":"ENG", "label_large":"button_live_subtitle_EN"}, {"option_id":"OFF", "label_large":"button_live_subtitle_off"}]}')
  
    // Obteniendo los audios
    if(value && value.audios && Array.isArray(value.audios)){
        settings_audios =  value.audios.map(audio =>{
            audio.id = audio.label_large;
            audio.label_large = Translator.get(audio.label_large, nameTagTemp(audio.label_large));
            return audio;
        });
        // console.log('[MA_LIVE]-settings_audios', settings_audios);
    }
    // Obteniendo los subtitulos
    if(value && value.subtitles && Array.isArray(value.subtitles)){
          settings_subtitles =  value.subtitles.map(subtitle =>{
          subtitle.id = subtitle.label_large;
          subtitle.label_large = Translator.get(subtitle.label_large, nameTagTemp(subtitle.label_large));
          return subtitle;
      });
      // console.log('[MA_LIVE]-settings_subtitles', settings_subtitles);
    }

  } catch (error) {
    console.log("[MA_LIVE]-loadLanguagesSettingsUser-error", error);
  }
};

const getVersionEpgChannel = function () {
  return 'v6.0';
}

const enabledChannelVersion = function () {
  return true;
}

const streamIsEnabled = function (stream){
  //Funcion que me indica si el streaming es permitido
  if(streamsMaEnabled && stream) {
    if(streamsMaEnabled[stream]){
      // console.log('[JONY]-streamType=>' + stream);
      return streamsMaEnabled[stream];
    }else{
      if(streamsMaEnabled['default']){
        return streamsMaEnabled['default'];
      }else{
        return false;
      }
    }
  }
  return false;
}

const isEnableCloseOnClick = function (){
  return true;
}


const isGroupIdEnabled = function (gid, stream){
        // console.log('[JONY]----stream==>' + stream);

        if (isAndroidDevice()) {
          // MA Siempre Activo para ADR
          return true;
        }

        if(!gid){
          return false;
        } else {
          return true;
        }

        // [EOER] - Se remueve validación de getGroupsIdsMA para habilitar experiencia MA en OTT
        // const  tmp = getGroupsIdsMA();
        // const idx = tmp && Array.isArray(tmp) && tmp.findIndex(tmp => tmp == gid);
        // if (Array.isArray(tmp) && tmp[idx]) {
          // se remueve de la condicion: streamIsEnabled(stream)  por issue [STV-8937]
        //   return true;         
        // }else{
        //   return false;
        // }
}



//Funcion que consulta metadata los streamsTypes para MA LIVE
const initGroupsIds = function () {
  try {
    const meta = Metadata.get("audio_subtitle_priority",'{"colombia":[791206], "default": []}');
    const objectMeta = JSON.parse(meta);
    const _region = getRegion();
    const value = objectMeta[_region] ? objectMeta[_region] : objectMeta["default"];
    if (value && typeof value === "object") {
      groupIdsEnabled = value;
    }
  } catch (error) {
    console.log("[MA_LIVE]-audio_subtitle_priority-error", error);
  }
};


const getGroupsIdsMA = function (){
  return groupIdsEnabled;
}

const createOptionsModal = function(value){
  let settings_audios_tmp = [];
  let settings_subtitles_tmp = [];
  // Obteniendo los audios
    if(value && value.audio && value.audio.options && Array.isArray(value.audio.options)){
        settings_audios_tmp =  value.audio.options.map(audio =>{
            // {"option_id":"ORIGINAL","label_large": "button_live_audio_ORIGINAL"}  
            audio.option_id = audio.track;
            const name = 'button_live_audio_' + audio.tag;
            audio.label_large = Translator.get((name, nameTagTemp(name)));
            return audio;
        });
    }
    // Obteniendo los subtitulos
    if(value && value.subtitle && value.subtitle.options && Array.isArray(value.subtitle.options)){
            settings_subtitles_tmp =  value.subtitle.options.map(subtitle =>{
              subtitle.option_id = subtitle.track;
              const name = 'button_live_subtitle_' + subtitle.tag;
              subtitle.label_large = Translator.get((name, nameTagTemp(name)));
              return subtitle;
            });
            
            // SI EXISTE AL MENOS UN SUBTITULO, SE AGREGA LA OPCION DE APAGAR.
            if(settings_subtitles_tmp.length > 0){
              const subtitle = {
                track: 'off',
                tag: 'off'
              };
              subtitle.option_id = subtitle.track;
              const name = 'button_live_subtitle_' + subtitle.tag;
              subtitle.label_large = Translator.get((name, nameTagTemp(name)));
              settings_subtitles_tmp.push(subtitle);
            }
    }

  return {
    audio: settings_audios_tmp,
    subtitles: settings_subtitles_tmp
  }
}


//Obtiene el nombre temporal de llaves
const nameTagTemp =  function (tagName) {
    let name = tagName;
    switch(tagName){
        case 'button_live_audio_ORIGINAL':
        case 'button_live_subtitle_ORIGINAL':
        case 'live_subtitle__button':
            name = 'Idioma Original'
        break;
        case 'button_live_audio_ES':
        case 'button_live_subtitle_ES':
        case 'button_live_audio_audio_spa':
        case 'live_subtitle_SPA_36SPA_button':
        case 'live_subtitle_caption_1SPA_button':
        case 'live_subtitle_SPASPA_button':
        case 'live_subtitle_subtitle_spa':
            name = 'Español'
        break;
        case 'button_live_audio_PT':
        case 'button_live_subtitle_PT':
            name = 'Portugués'
        break;
        case 'button_live_audio_EN':
        case 'button_live_audio_audio_eng':
        case 'button_live_subtitle_EN':
        case 'live_subtitle_ENGENG_button':
        case 'live_subtitle_Englishen_button':  
        case 'live_subtitle_caption_2ENG_button':  
        case 'live_subtitle_caption_3ENG_button':  
        case 'live_subtitle_caption_4ENG_button':
        case 'live_subtitle_subtitle_eng':
            name = 'Inglés'
        break;
        case 'label_live_subtitle_NA':
            name = 'No disponible'
            break;
        case 'button_live_subtitle_off':
            name = 'Apagado'
            break;
        case 'title_live_audio':
            name = 'Audio';
            break;
        case 'title_live_subtitle':
            name =  'Subtítulos';
            break;
        case 'button_live_audio_subtitle_exit':
            name = 'Cerrar';
            break;
        default:
            name = tagName;
          break;
    }
    return name;
}

//Funcion que consulta metadata los streamsTypes para MA LIVE
const initStremsEnabled = function () {
  try {
    const value = Utils.getApaMetadataKey("live_configuration_audio_subtitle",'{ "hls_kr": true,  "hls_kr_ma": true}');
    if (value && typeof value === "object") {
      streamsMaEnabled = value;
    }
  } catch (error) {
    console.log("[MA_LIVE]-initStremsEnabled-error", error);
  }
};

const getRegion = function (){
    const region = DeviceStorage.getItem("region");
    return region;
}

// Funcion que indica si esta activada la nueva experiencia de MA en LIVE
const isEnabled = function () {
  return enableMultipleLang;
};


// Obtener los audios para modal de settings
const getModalSettingsAudio = function(){
  return settings_audios;
}

// Obtener los subtitles para modal de settings
const getModalSettingsSubtitles = function(){
  return settings_subtitles;
}
const defaultOptionsModal = function () {
  return {
    audio:[],
    subtitle:[]
  }
}

const geTimerModalHide = function() {
  const timer = getTimeModalToClose();
  return timer * 1000;
};

const getTimeModalToClose = function() {
  let timer = 0;
  try {
    const meta = Metadata.get('audio_subtitle_timer_modal', '{"colombia": 10, "default": 10}');
    const objectMeta = JSON.parse(meta);
    const _region = getRegion();
    timer = objectMeta[_region] ? objectMeta[_region] : objectMeta['default'];
  } catch (error) {
    timer = 10;
    console.log('[MA_LIVE]-audio_subtitle_priority-error', error);
  }
  return timer;
};

const MultipleLangLive = {
  initialize,
  isEnabled,
  getModalSettingsAudio,
  getModalSettingsSubtitles,
  nameTagTemp,
  getVersionEpgChannel,
  streamIsEnabled,
  createOptionsModal,
  defaultOptionsModal,
  isEnableCloseOnClick,
  geTimerModalHide,
  enabledChannelVersion,
  getGroupsIdsMA,
  isGroupIdEnabled
};

export default MultipleLangLive;



// WEBPACK FOOTER //
// ./src/AAF/LanguageLive/MultipleLangLive.js